import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generarReporteColectivoTardanza = (asistencias) => {
  const doc = new jsPDF();

  // Asumimos que todos los registros son de la misma sucursal.
  const sucursalNombre = asistencias.length > 0 ? asistencias[0].sucursal || '-' : '-';

  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('Autosegurosa', 14, 15);

  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text(`Sucursal: ${sucursalNombre}`, 14, 22);

  doc.setFontSize(14);
  doc.text('Reporte Colectivo de Tardanzas', 14, 30);

  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const obtenerDiaSemana = (fecha) => diasSemana[fecha.getDay()];

  const tableData = [];

  // Filtrar solo registros con tardanza > 0
  const tardanzas = asistencias.filter(a => a.tardanza_minutos > 0);

  tardanzas.forEach((a) => {
    const fechaObj = new Date(a.fecha_hora);
    const diaSemana = obtenerDiaSemana(fechaObj);
    const fechaStr = `${fechaObj.getDate().toString().padStart(2, '0')}/${(fechaObj.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${fechaObj.getFullYear()}`;

    const horas = Math.floor(a.tardanza_minutos / 60);
    const minutos = a.tardanza_minutos % 60;
    const tardanzaStr = `${horas > 0 ? `${horas}h ` : ''}${minutos}min`;

    tableData.push([
      a.nombre,
      diaSemana,
      fechaStr,
      a.hora_entrada_permitida || '-',
      a.hora_entrada_real || '-',
      tardanzaStr,
    ]);
  });

  if (tableData.length === 0) {
    doc.setFontSize(14);
    doc.text('No se registraron tardanzas en este período.', 14, 40);
    doc.save('reporte_colectivo_tardanzas.pdf');
    return;
  }

  autoTable(doc, {
    startY: 40,
    head: [['Empleado', 'Día', 'Fecha', 'Hora Permitida', 'Hora Real', 'Tardanza']],
    body: tableData,
    styles: { fontSize: 10 },
  
  });

  doc.save('reporte_colectivo_tardanzas.pdf');
};
